// Copyright (c) 2024 embyt GmbH. All rights reserved.
// Author: Roman Morawek

import * as APITypes from "./api";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

// list rfid data, but omit fields which need subqueries to improve performance
export const listRfidsBasic =
  /* GraphQL */ `query ListRfidsBasic($changesSince: Int, $rfid: String, $siteId: Int) {
  listRfids(changesSince: $changesSince, rfid: $rfid, siteId: $siteId) {
    accessRights
    category
    chargerRestricted
    id
    isActive
    lastChange
    limitCost
    limitEnd
    limitEnergy
    limitPeriod
    limitStart
    maxPowerAc
    maxPowerDc
    carName
    carBattery
    additionalData
    name
    rfid
    siteId
    __typename
  }
}
` as GeneratedQuery<APITypes.ListRfidsQueryVariables, APITypes.ListRfidsQuery>;

// list users, but omit fields which need subqueries to improve performance
export const listUsersBasic = /* GraphQL */ `query ListUsersBasic {
  listUsers {
    accessRights
    companyId
    email
    id
    name
    secondaryId
    __typename
  }
}
` as GeneratedQuery<APITypes.ListUsersQueryVariables, APITypes.ListUsersQuery>;
